import React, { useContext, Suspense } from 'react';
import '../Assets/styles/MainContent.css';
import { MenuContext } from '../Pages/Dashboard/dashboard';
import { PathJson } from './componentPath';
import { IoClose } from "react-icons/io5";
import { CgCloseO } from "react-icons/cg";
import { GrClose } from "react-icons/gr";
import { IoCloseCircle } from "react-icons/io5";
import { IoMdCloseCircle } from "react-icons/io";
import { CgCloseR } from "react-icons/cg";

const MainContent = () => {
  const { openTabs, activeTab, setActiveTab, setSelectedMenu, setFormID, closeTab, UnitId, UserPermissions,openMenuTab, setFormPermissions, setUnitId,userPermissionsMap, ...context } = useContext(MenuContext);
  const defaultPermissions= {isAdd:false,
      isEdit: false,
      isView: false,
      isDelete: false,
      isNotification: false }
  return (
    <main className="main-content">
      {/* Tabs Header */}
      <div className="tabs-header" style={{ display: 'flex', background: '#fff', padding: '4px', overflowX: 'auto' }}>
        {openTabs
        .filter(tab => (tab.title !== 'Dashboard' && tab.title !== ''))
        .map(tab => (
          <div
            key={tab.title}
            style={{
              padding: '0px 6px',
              marginRight: '2px',
              border: activeTab === tab.title ? '2px solid #31d9a2' : '1px solid #e8e3e3ff',
              borderRadius: '4px',
              background: activeTab === tab.title ? '#31d9a2' : '#e8e3e3ff',
              color: activeTab === tab.title ? '#fff' : '#000',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={() => {
              setActiveTab(tab.title);
              setSelectedMenu(tab.title);
              setFormID(tab.FormID);
            }}
          >
            <span><b>{tab.title}</b></span>
            {tab.title !== 'Dashboard' && (
              <span
                style={{ marginLeft: '5px', cursor: 'pointer', color: 'red', paddingTop:'7px' }}
                onClick={(e) => { e.stopPropagation(); closeTab(tab.title); }}
              >
              {activeTab === tab.title ? <CgCloseR /> : <b><CgCloseR /></b> }  
              </span>
            )}
          </div>
        ))}
      </div>

      {/* Tab Contents */}
      {openTabs.map(tab => {
        const DynamicComponent = PathJson[tab.FormID];
        if (!DynamicComponent) return <div key={tab.title}>Form Under development , Please Contact Admin</div>;

        return (
          <div key={tab.title} style={{ display: activeTab === tab.title ? 'block' : 'none' }} className='childrenDiv'>
            <Suspense fallback={<div>Loading...</div>}>
              <DynamicComponent
                alert={context.alert}
                setSelectedMenu={setSelectedMenu}
                setFormID={setFormID}
                UnitId={UnitId}
                // UserPermissions={UserPermissions}
                UserPermissions={userPermissionsMap[tab.FormID] || defaultPermissions}
              />
            </Suspense>
          </div>
        );
      })}
    </main>
  );
};

export default MainContent;
